import {ChangeEvent, forwardRef, useCallback} from 'react';
import {twMerge} from '../../../common/twMerge';
import {getTrimmedTextEvent} from '../../../common/util/getTrimmedTextEvent';
import {InputV2Props} from './inputV2Props.interface';

export const InputV2 = forwardRef<HTMLInputElement, InputV2Props>(
  ({className, value, onChange: _onChange, type, maxLength, ...props}, ref) => {
    // input type이 number일 때, 한글입력을 막기 위해 정규식으로 숫자만 들어오는지 확인합니다.
    const onChange = useCallback(
      (e: ChangeEvent<HTMLInputElement>) => {
        if (type === 'number' && _onChange) {
          const testNativeData = NUMBER_REGEXP.test(
            (e.nativeEvent as InputEvent).data as string
          );
          const testTargetValue = NUMBER_REGEXP.test(e.target.value);
          if (
            testNativeData ||
            testTargetValue ||
            (e.nativeEvent as InputEvent).data === null
          ) {
            _onChange(maxLength ? getTrimmedTextEvent(e, maxLength) : e);
            return null;
          }
        } else if (_onChange) {
          _onChange(maxLength ? getTrimmedTextEvent(e, maxLength) : e);
        }
      },
      [type, _onChange, maxLength]
    );
    return (
      <div className="flex w-full items-center overflow-hidden">
        <input
          className={twMerge(
            'font-medium2 flex-1 bg-transparent text-theme-solid-100 outline-hidden placeholder:text-theme-solid-40 disabled:placeholder:text-theme-solid-40 disabled:text-theme-solid-40 disabled:cursor-not-allowed min-w-0',
            'disabled:[-webkit-text-fill-color]:text-theme-solid-40 disabled:opacity-100 disabled:bg-theme-solid-10',
            'placeholder-shown:text-ellipsis',
            className
          )}
          ref={ref}
          type={type}
          value={value ?? ''}
          onChange={onChange}
          {...props}
        />
      </div>
    );
  }
);

InputV2.displayName = 'InputV2';
const NUMBER_REGEXP = /\d/g;
